import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireRoles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FC]">
        <div className="flex flex-col items-center gap-3" data-testid="auth-loading">
          <div className="h-10 w-10 rounded-full border-2 border-[#E8ECF2] border-t-[#1A3A5C] animate-spin" />
          <p className="text-sm text-[#555568]">Loading WYLO…</p>
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (requireRoles && !requireRoles.includes(user.role)) {
    return <Navigate to="/app" replace />;
  }
  return children;
}
